import React, { Component } from 'react'
import classes from './Collector.css'
import CollectorImg from './img/Collector_img.jpg'
import { Route, NavLink } from 'react-router-dom'
import Construction from './Collector Constaruction/Constaruction'
import WorkInfo from './work-principle/workInfo'
class Collector extends Component {
    render() {
        return (
            <div className={classes.Collector}>

                <div className={classes.title}>
                    <h1>СОЛНЕЧНЫЙ ФОТОЭЛЕКТРИЧЕСКИЙ МОДУЛЬ (патент №2717695)</h1>
                </div>
                <div className='container'>
                    <div className='row'>
                        <div className='col-2'>
                            <div className={classes.MenuNavContainer}>
                                <ul className={classes.MenuNavUl}>
                                    <li className={classes.MenuNavLi}>
                                        <div className={classes.MenuNavBlock}>
                                            <NavLink to='/collector/construction'>Конструкция</NavLink>
                                        </div>
                                    </li>
                                    <li className={classes.MenuNavLi}>
                                        <div className={classes.MenuNavBlock}>
                                            <NavLink to='/collector/work-principle'>Принцип работы</NavLink>
                                        </div>
                                    </li>
                                    <li className={classes.MenuNavLi}>
                                        <div className={classes.MenuNavBlock}>
                                            <NavLink to='/'>Преимущества</NavLink>
                                        </div>
                                    </li>
                                    <li className={classes.MenuNavLi}>
                                        <div className={classes.MenuNavBlock}>
                                            <NavLink to='/'>Экономика</NavLink>
                                        </div>
                                    </li>
                                    <li className={classes.MenuNavLi}>
                                        <div className={classes.MenuNavBlock}>
                                            <NavLink to='/'>Экология</NavLink>
                                        </div>
                                    </li>
                                    <li className={classes.MenuNavLi}>
                                        <div className={classes.MenuNavBlock}>
                                            <NavLink to='/'>Патент</NavLink>
                                        </div>
                                    </li>
                                    <li className={classes.MenuNavLi}>
                                        <div className={classes.MenuNavBlock}>
                                            <NavLink to='/'>Статьи/презентации</NavLink>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-4'>
                            <img className={classes.CollectorImg} src={CollectorImg} alt=''></img>
                        </div>
                        <div className='col-6'>
                            <div className={classes.description}>
                                <h2 className={classes.H2}>ОБЕСПЕЧИВАЕТ:</h2>

                                <ul>
                                    <li>
                                        <p> • концентрацию солнечной энергии (от сотен КВт до 1 ГВт) с повышением КПД преобразования, при кардинальном уменьшение размеров,</p>
                                    </li>
                                    <li>
                                        <p> • возможность транспортировки солнечного фотоэлектрического модуля на геостационарную орбиту в упакованном виде (минимальный вес),</p>
                                    </li>
                                    <li>
                                        <p> • оперативном разворачиваниу его в воздушно-космическом пространстве без участия человека.</p>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>



            </div>

        )
    }
}
export default Collector


// WEBPACK FOOTER //
// ./src/containers/Collector/Collector.js